export default __webpack_public_path__ + "static/media/pdfFileIcon.998ad2f4.svg";